export default {
  SERVICE_PAID: "service/PAID"
};
